const HouseDescription = () => import(/* webpackChunkName 'HouseDescription' */ '@/components/Astrology/BirthChart/HouseDescription/HouseDescriptionList/HouseDescriptionList.vue');
const PlanetDescription = () => import(/* webpackChunkName 'PlanetDescription' */ '@/components/Astrology/BirthChart/PlanetDescription/PlanetDescriptionList/PlanetDescriptionList.vue');
const PlanetInSign = () => import(/* webpackChunkName 'PlanetInSign' */ '@/components/Astrology/BirthChart/PlanetInSign/PlanetInSignList/PlanetInSignList.vue');

export default {
    path: 'birth-chart',
    name: 'BirthChart',
    redirect: 'house-description/',
    meta: {
        label: 'Birth Chart'
    },
    component: {
        name: 'BirthChart',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'house-description',
            name: 'house-description',
            meta: {
                // accessLevel: USER_LIST,
                label: 'House Description'
            },
            component: HouseDescription
        },
        {
            path: 'planet-description',
            name: 'planet-description',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Planet Description'
            },
            component: PlanetDescription
        },
        {
            path: 'planet-in-sign',
            name: 'planet-in-sign',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Planet in Sign'
            },
            component: PlanetInSign
        }
    ]
};